import { memo } from 'react';

import LoginPopupDefaultMethod from '../../defaultMethod/presentation/LoginPopupDefaultMethodDialog';
import LoginPopupMultipleMethods from '../../multipleMethods/presentation/LoginPopupMultipleMethods.bindings';

import { Handlers, State } from './useLoginPopup';

interface Props {
  handlers: Handlers;
  state: State;
}

const LoginPopupPresentation = (props: Props): React.JSX.Element => {
  const { handlers, state } = props;

  if (!state.isOpen) {
    return null;
  }

  return state.isDefaultTwoFactorAuthenticationMode ? (
    <LoginPopupDefaultMethod
      code={state.code}
      errorMessage={state.errorMessage}
      isLoading={state.isLoading}
      isOpen={state.isOpen}
      onCodeUpdate={handlers.handleCodeUpdate}
      onResendCode={handlers.handleResendCode}
      onCallMe={handlers.handleCallMe}
      onSubmitCode={handlers.handleCodeSubmit}
      onSwitchToMultipleMode={handlers.handleSwitchToMultipleMode}
      onClose={handlers.handleClose}
      twoFactorDisplayName={state.selectedTwoFactorAuthentication?.displayName}
      twoFactorAuthenticationType={state.selectedTwoFactorAuthentication?.type}
      numberOfTwoFactorAuthentications={state.twoFactorAuthentications.length}
      onRememberDeviceChange={handlers.handleRememberDeviceChange}
      rememberDevice={state.isRememberDevice}
    />
  ) : (
    <LoginPopupMultipleMethods
      code={state.code}
      errorMessage={state.errorMessage}
      isLoading={state.isLoading}
      isOpen={state.isOpen}
      onClose={handlers.handleClose}
      onCodeUpdate={handlers.handleCodeUpdate}
      onRememberDeviceChange={handlers.handleRememberDeviceChange}
      onSubmitCode={handlers.handleCodeSubmit}
      onTwoFactorAuthenticationChange={handlers.handleTwoFactorAuthenticationChange}
      onClearInput={handlers.handleClearInput}
      onResendCode={handlers.handleResendCode}
      onCallMe={handlers.handleCallMe}
      rememberDevice={state.isRememberDevice}
      selectedTwoFactorAuthentication={state.selectedTwoFactorAuthentication}
      twoFactorAuthentications={state.twoFactorAuthentications}
    />
  );
};

export default memo(LoginPopupPresentation);
